import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntPopup from '../AntPopup';
import AntDeleteGrid from './AntDeleteGrid';
import AntLocalization from '../../utils/AntLocalization';
import notify from 'devextreme/ui/notify';

const REVIEW_PAGE_SIZE = 12;

export default forwardRef(function (props, ref) {
    const show = (objs) => {
        if (!objs || objs instanceof Array == false || objs.length <= 0) return;

        setDeleteObjs(objs);
    };

    const onAction = async (button) => {
        if (button && button.id == 'btnDelete') {
            var result = await props.API.postDelete(deleteObjs);

            // Luật configDelete chặn ở server: hiện đúng lý do của luật. Không xoá được dòng nào → phản hồi là lỗi;
            // xoá được một phần → phản hồi thành công kèm `errors` cho các dòng bị chặn.
            var blockedReasons = [];
            if (result && typeof result.error === 'string' && result.error) blockedReasons = [result.error];
            else if (result && result.data && result.data.errors instanceof Array) blockedReasons = result.data.errors;
            blockedReasons = blockedReasons.filter((reason, index) => typeof reason === 'string' && reason && blockedReasons.indexOf(reason) === index);
            if (blockedReasons.length > 0) notify(blockedReasons.join(' · '), 'error', 5000);

            if (!result || !result.data || !result.data.deleted) {
                // Không xoá được: nạp lại bảng xác nhận để từng dòng hiện đúng trạng thái xoá được/không.
                if (blockedReasons.length > 0) setDeleteObjs((objs) => [...objs]);
                return false;
            }
            if (props.onDeleted) props.onDeleted();
        }
        return true;
    };

    const onValidated = async (canDelete) => {
        if (deleteObjs.length <= 0) {
            if (popup.current) popup.current.close();
            return;
        }

        setButtons(
            canDelete
                ? [
                      {
                          id: 'btnDelete',
                          icon: 'trash',
                          text: AntLocalization.translateText({ vi: 'Xóa', en: 'Delete', fr: 'Supprimer', es: 'Eliminar', id: 'Hapus', ja: '削除', zh: '删除', ko: '삭제', hi: 'हटाएं', ar: 'حذف' }),
                          waiting_text: AntLocalization.translateText({ vi: 'Đang xoá ...', en: 'Deleting ...', fr: 'Suppression ...', es: 'Eliminando ...', id: 'Menghapus ...', ja: '削除中 ...', zh: '正在删除 ...', ko: '삭제 중 ...', hi: 'हटा रहे हैं ...', ar: 'جارٍ الحذف ...' }),
                          width: 160
                      }
                  ]
                : []
        );

        setWarningText(
            canDelete
                ? ''
                : AntLocalization.translateText({ vi: 'Không thể xóa dữ liệu !', en: 'Cannot delete !', fr: 'Suppression impossible !', es: '¡No se puede eliminar!', id: 'Tidak dapat menghapus !', ja: '削除できません！', zh: '无法删除数据！', ko: '삭제할 수 없습니다!', hi: 'डेटा हटाया नहीं जा सकता !', ar: 'تعذر حذف البيانات!' })
        );
    };

    const showPopup = () => {
        if (popup.current && deleteObjs instanceof Array) {
            popup.current.setHeight(Math.min(740, Math.max(360, Math.min(deleteObjs.length, REVIEW_PAGE_SIZE) * 34 + 290)));
            popup.current.show();
        }
    };

    const [buttons, setButtons] = useState([]);
    const [deleteObjs, setDeleteObjs] = useState([]);
    const [warningText, setWarningText] = useState('');

    const popup = useRef();
    const grid = useRef();

    useImperativeHandle(ref, () => ({
        show: show
    }));

    useEffect(() => {
        if (deleteObjs instanceof Array && deleteObjs.length > 0) {
            showPopup();
        }
    }, [deleteObjs]);

    
    return (
        <React.Fragment>
            <AntPopup
                ref={popup}
                isGray={true}
                height={Math.min(740, Math.max(360, Math.min(deleteObjs.length, REVIEW_PAGE_SIZE) * 34 + 290))}
                width={props.width ? props.width : 900}

                autoHeight={true}
                autoWidth={true}
                deferRendering={true}
                title={`${AntLocalization.translateText({ vi: 'Xóa', en: 'Delete', fr: 'Supprimer', es: 'Eliminar', id: 'Hapus', ja: '削除', zh: '删除', ko: '삭제', hi: 'हटाएं', ar: 'حذف' })} ${String(props.API.entityDisplay).toLowerCase()}`}
                onAction={onAction}
                widgets={buttons}
                hideOnOutsideClick={props.hideOnOutsideClick !== undefined ? props.hideOnOutsideClick : true}
            >
                {warningText && <span className="ant-header-text ant-error-text">{warningText}</span>}

                {!warningText && (
                    <span className="ant-form-title">{`${AntLocalization.translateText({ vi: 'Bạn có muốn xóa', en: 'Do you want to delete', fr: 'Voulez-vous supprimer', es: '¿Desea eliminar', id: 'Ingin menghapus', ja: '削除しますか:', zh: '是否删除', ko: '삭제하시겠습니까:', hi: 'क्या हटाना चाहते हैं:', ar: 'هل تريد حذف' })} ${String(props.API.entityDisplay).toLowerCase()} ?`}</span>
                )}
                <AntDeleteGrid
                    ref={grid}
                    API={props.API}
                    entity_key={props.entity_key ? props.entity_key : 'id'}
                    dataRows={deleteObjs}
                    fields={props.fields}
                    columns={props.columns}
                    pageSize={props.pageSize || REVIEW_PAGE_SIZE}
                    deletable={true}
                    onValidated={onValidated}
                    onItemRemoved={setDeleteObjs}
                />
            </AntPopup>
        </React.Fragment>
    );
});
